import axios from "axios";
import { useContext } from "react";
import AliceCarousel from "react-alice-carousel";
import 'react-alice-carousel/lib/alice-carousel.css';
import { Link } from "react-router-dom";
import { numberWithCommas } from "../config/CoinAPI";
import LoadingRing from "./LoadingRing";
import {TrendingContext} from "../pages/context/TrendingContext";

const Carousel1 = () => {
//  const [trending, setTrending] = useState([]);
//  const [currency,setcurrency]=useState(['usd']);
//  fetch data when component mounts
//   const fetchTrendingCoins = async () => {
  //     try{
    //     const { data } = await axios.get(TrendingCoins(currency));
    //     console.log(data);
    //     setTrending(data);
//     }
//     catch(error){
//       console.log(error);
//       return ;
//     }
//   };

//   useEffect(() => {
  //     fetchTrendingCoins();
  //   }, [currency]);
  
  const {trending}=useContext(TrendingContext);

  console.log("trendingcoins",trending);
  if(!trending||trending.length==0)
  return (
  <div className="text-center mt-5 w-11/12 mx-auto">
    Wait, Moment
    <LoadingRing/>
  </div> 
  )

  const items = trending.map((coin) => {
    let profit = coin?.price_change_percentage_24h >= 0;
    return (
      <Link className="flex items-center border-l
       border-sky-100 p-9 justify-center cursor-pointer uppercase bg-slate-200 gap-x-4" to={`/coins/${coin.id}`}>
        <img
          src={coin?.image}
          alt={coin.name}
          height="90"
          style={{ marginBottom: 20,width:50 }}
        />
        <span className="text-xl font-bold ml-3">
          {coin?.symbol}
          &nbsp;
          <span
            style={{
              color: profit > 0 ? "rgb(14, 203, 129)" : "red",
              fontWeight: 500,
              textAlign:"center",
            }}
          >
            {profit && "+"}
            {coin?.price_change_percentage_24h?.toFixed(2)}%
          </span>
        </span>
        <span style={{ fontSize: 22, fontWeight: 500 }}>
          {'$'} {numberWithCommas(coin?.current_price.toFixed(2))}
        </span>
      </Link>
    );
  });

  const responsive = {
    0: {
      items: 2,
    },
    512: {
      items: 4,
    },
  };

  return (
    <div className="h-1/2 flex items-center">
      <AliceCarousel mouseTracking infinite autoPlayInterval={1000} animationDuration={1500}
        disableDotsControls disableButtonsControls responsive={responsive} items={items} autoPlay
      />
    </div>
  );
};

export default Carousel1;
